import { object, string } from '@gogame/schemas';

export const cohortsSettingsSchema = object(
  {
    metric: string().default(''),
  },
  'cohortsSettings'
);
